export default __webpack_public_path__ + "static/media/materiaprima-02.c9a4b704.jpg";